export function getdata(){
	var obj = {
			jbrlx:[
				{
					lebal:'201',
					value:'居民身份证'
				},{
					lebal:'202',
					value:'军官证'
				},{
					lebal:'203',
					value:'武警警官证'
				},{
					lebal:'204',
					value:'士兵证'
				},{
					lebal:'205',
					value:'军队离退休干部证'
				},{
					lebal:'206',
					value:'残疾人证'
				},{
					lebal:'207',
					value:'残疾军人证（1-8级）'
				},{
					lebal:'208',
					value:'外国护照'
				},{
					lebal:'209',
					value:'港澳同胞回乡证'
				},{
					lebal:'210',
					value:'港澳居民来往内地通行证'
				},{
					lebal:'211',
					value:'台胞证'
				},{
					lebal:'212',
					value:'中华人民共和国往来港澳通行证'
				},{
					lebal:'213',
					value:'台湾居民来往大陆通行证'
				},{
					lebal:'214',
					value:'大陆居民往来台湾通行证'
				},{
					lebal:'215',
					value:'外国人居留证'
				},{
					lebal:'216',
					value:'外交官证'
				},{
					lebal:'217',
					value:'领事馆证'
				},{
					lebal:'218',
					value:'海员证'
				},{
					lebal:'219',
					value:'香港身份证'
				},{
					lebal:'220',
					value:'台湾身份证'
				},{
					lebal:'221',
					value:'澳门身份证'
				},{
					lebal:'222',
					value:'外国人身份证件'
				},{
					lebal:'223',
					value:'高校毕业生自主创业证'
				},{
					lebal:'224',
					value:'就业失业登记证'
				},{
					lebal:'225',
					value:'退休证'
				},{
					lebal:'226',
					value:'离休证'
				},{
					lebal:'227',
					value:'中国护照'
				},{
					lebal:'228',
					value:'城镇退役士兵自谋职业证'
				},{
					lebal:'233',
					value:'外国人永久居留证'
				},{
					lebal:'234',
					value:'就业创业证'
				},{
					lebal:'291',
					value:'医学出生证明'
				},{
					lebal:'299',
					value:'其他个人证件'
				},
			],
			headData:[
				{
					title: "项目",
					prop: "title",
					width:"35px",
					
					fixed:'left',
					custom:true
				},
				{
					title: "项目2",
					prop: "coloum",
					width:"220px",
					align:"left",
					custom:true
				},
				{
					title: "栏次",
					prop: "grade",
					custom:true,
					width:"80px",
				},
				{
					title: "一般项目",
					prop: "",
					children:[
						{
						title: "本月数",
						prop: "zzs_0_x_1",
						
						custom:true,
						width:"115px",
						},
						{
						title: "本年累计",
						prop: "zzs_0_x_2",
						
						custom:true,
						width:"115px",
						}
					]
				},
				{
					title: "即征即退项目",
					prop: "",
					children:[
						{
						title: "本月数",
						prop: "zzs_0_x_3",
						custom:true,
						
						width:"115px",
						},
						{
						title: "本年累计",
						prop: "zzs_0_x_4",
						custom:true,
						
						width:"115px",
						}
					]
				},
			],
			tableData:[
				{
					title:"销售额",
					coloum:"（一）按使用税率计税销售额",
					grade:"1",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
					
				},
				{
					title:"销售额",
					coloum:"其中：应税货物销售额",
					grade:"2",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
				},
				{
					title:"销售额",
					coloum:"应税劳务销售额",
					grade:"3",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
				},
				{
					title:"销售额",
					coloum:"纳税检查调整的销售额",
					grade:"4",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"销售额",
					coloum:"（二）按简易办法计税销售额",
					grade:"5",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
				},
				{
					title:"销售额",
					coloum:"其中：纳税检查调整的销售额",
					grade:"6",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
				},
				{
					title:"销售额",
					coloum:"（三）免、抵、退办法出口销售额",
					grade:"7",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"销售额",
					coloum:"（四）免税销售额",
					grade:"8",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"销售额",
					coloum:"其中：免税货物销售额",
					grade:"9",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_2:true,
					// issgtableitemstyle:true
				},
				{
					title:"销售额",
					coloum:"免税劳务销售额",
					grade:"10",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_2:true,
				},
				{
					title:"税款计算",
					coloum:"销项税额",
					grade:"11",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"税款计算",
					coloum:"进项税额",
					grade:"12",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
				},
				{
					title:"税款计算",
					coloum:"上期抵留税额",
					grade:"13",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"税款计算",
					coloum:"进项税额转出",
					grade:"14",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
				},
				{
					title:"税款计算",
					grade:"15",
					coloum:"免、抵、退应退税额",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_2:true,
				},
				{
					title:"税款计算",
					grade:"16",
					coloum:"按适用税率计算的纳税检查应补缴税额",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_2:true,
				},
				{
					title:"税款计算",
					grade:"17=12+13-14-15+16",
					coloum:"应抵扣税额合计",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"税款计算",
					grade:"18（如17<11，则为17，否则为11）",
					coloum:"实际抵扣税额",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"税款计算",
					coloum:"应纳税额",
					grade:"19=11-18",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"税款计算",
					coloum:"期末留抵税额",
					grade:"20=17-18",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"税款计算",
					grade:"21",
					coloum:"简易计税办法计算的应纳税额",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"税款计算",
					grade:"22",
					coloum:"按简易计税办法计算的纳税检查应补缴税额",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_2:true,
				},
				{
					title:"税款计算",
					coloum:"应纳税额减征额",
					grade:"23",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
				},
				{
					title:"税款计算",
					grade:"24=19+21-23",
					coloum:"应纳税额合计",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"税款缴纳",
					grade:"25",
					coloum:"期初未缴税额",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"税款缴纳",
					grade:"26",
					coloum:"实收出口开具专用缴款书退税额",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"税款缴纳",
					grade:"27=28+29+30+31",
					coloum:"本期已缴税额",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"税款缴纳",
					grade:"28",
					coloum:"①分次预缴税额",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
				},
				{
					title:"税款缴纳",
					grade:"29",
					coloum:"②出口开具专用缴款书预缴税额",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"税款缴纳",
					grade:"30",
					coloum:"③本期缴纳上期应纳税额",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
				},
				{
					title:"税款缴纳",
					grade:"31",
					coloum:"④本期缴纳欠缴税额",
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
				},
				{
					title:"税款缴纳",
					grade:"32=24+25+26-27",
					coloum:"期末未缴税额（多缴为负数）",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"税款缴纳",
					grade:"33=25+26-27",
					coloum:"其中：欠缴税额（≥0）",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"税款缴纳",
					grade:"34＝24-28-29",
					coloum:"本期应补（退）税额",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"税款缴纳",
					grade:"35",
					coloum:"即征即退实际退税额",
					disabledzzs_0_x_1:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
				},
				{
					title:"税款缴纳",
					grade:"36",
					coloum:"期初未缴查补税额",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"税款缴纳",
					grade:"37",
					coloum:"本期入库查补税额",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_4:true,
				},
				{
					title:"税款缴纳",
					grade:"38=16+22+36-37",
					coloum:"期末未缴查补税额",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"附加税费",
					grade:"39",
					coloum:"城市维护建设税本期应补（退）税额",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"附加税费",
					grade:"40",
					coloum:"教育费附加本期应补（退）费税",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_1:true,
				},
				{
					title:"附加税费",
					grade:"41",
					coloum:"地方教育附加本期补（退）费额",
					disabledzzs_0_x_3:true,
					disabledzzs_0_x_2:true,
					disabledzzs_0_x_4:true,
					disabledzzs_0_x_1:true,
				},
			]
		
	}
	return obj
}
